const headerBackgrounds = document.querySelectorAll('[data-component="mol-header-background"]');

if (headerBackgrounds.length > 0) {
  const desktopMediaQuery = window.matchMedia('(min-width: 1201px)');
  const edgeOffset = 40;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  headerBackgrounds.forEach((container) => {
    const items = container.querySelectorAll('.header-background__item');
    const isWithImage = container.classList.contains('header-background--with-image');

    if (!items.length) {
      return;
    }

    let isInViewport = false;
    let rafId = null;

    const resetItems = () => {
      items.forEach((item) => {
        item.style.transform = '';
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isInViewport = entry.isIntersecting;

          if (!isInViewport) {
            resetItems();
          }
        });
      },
      { threshold: 0.5 },
    );

    observer.observe(container);

    const measureVisualBounds = (item) => {
      item.style.transform = '';
      const visual = item.querySelector('svg, img') || item;
      const containerRect = container.getBoundingClientRect();
      const visualRect = visual.getBoundingClientRect();

      return {
        width: containerRect.width,
        height: containerRect.height,
        left: visualRect.left - containerRect.left,
        top: visualRect.top - containerRect.top,
        right: visualRect.right - containerRect.left,
        bottom: visualRect.bottom - containerRect.top,
      };
    };

    const moveItems = (event) => {
      if (!isInViewport || !desktopMediaQuery.matches) {
        return;
      }

      const offsetX = (event.clientX - window.innerWidth / 3) * 0.025;
      const offsetY = (event.clientY - window.innerHeight) * 0.025;

      items.forEach((item, index) => {
        const directionX = index % 3 === 0 ? 2 : -2;
        const directionY = index % 3 === 0 ? -2 : 2;
        const movementScale = (index + 2) * 0.2;
        const isItem2WithImage = isWithImage && item.classList.contains('header-background__item--2');
        const movementScaleY = isItem2WithImage ? movementScale * 2 : movementScale;

        let x = offsetX * directionX * movementScale;
        let y = offsetY * directionY * movementScaleY;

        const bounds = measureVisualBounds(item);

        x = clamp(x, edgeOffset - bounds.left, bounds.width - edgeOffset - bounds.right);
        y = clamp(y, edgeOffset - bounds.top, bounds.height - edgeOffset - bounds.bottom);

        item.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      });
    };

    const onMouseMove = (event) => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      rafId = requestAnimationFrame(() => {
        moveItems(event);
        rafId = null;
      });
    };

    document.addEventListener('mousemove', onMouseMove);

    desktopMediaQuery.addEventListener('change', (event) => {
      if (!event.matches) {
        resetItems();
      }
    });
  });
}
